import arClients from './locales/ar/clients.json';
import arComponents from './locales/ar/components.json';
import arDocbuilder from './locales/ar/docbuilder.json';
import arSessions from './locales/ar/sessions.json';
import csClients from './locales/cs/clients.json';
import csComponents from './locales/cs/components.json';
import csDocbuilder from './locales/cs/docbuilder.json';
import csSessions from './locales/cs/sessions.json';
import daClients from './locales/da/clients.json';
import daComponents from './locales/da/components.json';
import daDocbuilder from './locales/da/docbuilder.json';
import daSessions from './locales/da/sessions.json';
import deClients from './locales/de/clients.json';
import deComponents from './locales/de/components.json';
import deDocbuilder from './locales/de/docbuilder.json';
import deSessions from './locales/de/sessions.json';
import enClients from './locales/en/clients.json';
import enComponents from './locales/en/components.json';
import enDocbuilder from './locales/en/docbuilder.json';
import enSessions from './locales/en/sessions.json';
import esClients from './locales/es/clients.json';
import esComponents from './locales/es/components.json';
import esDocbuilder from './locales/es/docbuilder.json';
import esSessions from './locales/es/sessions.json';
import frClients from './locales/fr/clients.json';
import frComponents from './locales/fr/components.json';
import frDocbuilder from './locales/fr/docbuilder.json';
import frSessions from './locales/fr/sessions.json';
import hiClients from './locales/hi/clients.json';
import hiComponents from './locales/hi/components.json';
import hiDocbuilder from './locales/hi/docbuilder.json';
import hiSessions from './locales/hi/sessions.json';
import huClients from './locales/hu/clients.json';
import huComponents from './locales/hu/components.json';
import huDocbuilder from './locales/hu/docbuilder.json';
import huSessions from './locales/hu/sessions.json';
import itClients from './locales/it/clients.json';
import itComponents from './locales/it/components.json';
import itDocbuilder from './locales/it/docbuilder.json';
import itSessions from './locales/it/sessions.json';
import jaClients from './locales/ja/clients.json';
import jaComponents from './locales/ja/components.json';
import jaDocbuilder from './locales/ja/docbuilder.json';
import jaSessions from './locales/ja/sessions.json';
import koClients from './locales/ko/clients.json';
import koComponents from './locales/ko/components.json';
import koDocbuilder from './locales/ko/docbuilder.json';
import koSessions from './locales/ko/sessions.json';
import nlClients from './locales/nl/clients.json';
import nlComponents from './locales/nl/components.json';
import nlDocbuilder from './locales/nl/docbuilder.json';
import nlSessions from './locales/nl/sessions.json';
import ptClients from './locales/pt/clients.json';
import ptComponents from './locales/pt/components.json';
import ptDocbuilder from './locales/pt/docbuilder.json';
import ptSessions from './locales/pt/sessions.json';
import skClients from './locales/sk/clients.json';
import skComponents from './locales/sk/components.json';
import skDocbuilder from './locales/sk/docbuilder.json';
import skSessions from './locales/sk/sessions.json';
import trClients from './locales/tr/clients.json';
import trComponents from './locales/tr/components.json';
import trDocbuilder from './locales/tr/docbuilder.json';
import trSessions from './locales/tr/sessions.json';
import zhCnClients from './locales/zh-CN/clients.json';
import zhCnComponents from './locales/zh-CN/components.json';
import zhCnDocbuilder from './locales/zh-CN/docbuilder.json';
import zhCnSessions from './locales/zh-CN/sessions.json';
import zhHkClients from './locales/zh-HK/clients.json';
import zhHkComponents from './locales/zh-HK/components.json';
import zhHkDocbuilder from './locales/zh-HK/docbuilder.json';
import zhHkSessions from './locales/zh-HK/sessions.json';

import type { Resource } from 'i18next';

export const resources: Resource = {
  ar: { sessions: arSessions, clients: arClients, components: arComponents, docbuilder: arDocbuilder },
  cs: { sessions: csSessions, clients: csClients, components: csComponents, docbuilder: csDocbuilder },
  da: { sessions: daSessions, clients: daClients, components: daComponents, docbuilder: daDocbuilder },
  de: { sessions: deSessions, clients: deClients, components: deComponents, docbuilder: deDocbuilder },
  en: { sessions: enSessions, clients: enClients, components: enComponents, docbuilder: enDocbuilder },
  es: { sessions: esSessions, clients: esClients, components: esComponents, docbuilder: esDocbuilder },
  fr: { sessions: frSessions, clients: frClients, components: frComponents, docbuilder: frDocbuilder },
  hi: { sessions: hiSessions, clients: hiClients, components: hiComponents, docbuilder: hiDocbuilder },
  hu: { sessions: huSessions, clients: huClients, components: huComponents, docbuilder: huDocbuilder },
  it: { sessions: itSessions, clients: itClients, components: itComponents, docbuilder: itDocbuilder },
  ja: { sessions: jaSessions, clients: jaClients, components: jaComponents, docbuilder: jaDocbuilder },
  ko: { sessions: koSessions, clients: koClients, components: koComponents, docbuilder: koDocbuilder },
  nl: { sessions: nlSessions, clients: nlClients, components: nlComponents, docbuilder: nlDocbuilder },
  pt: { sessions: ptSessions, clients: ptClients, components: ptComponents, docbuilder: ptDocbuilder },
  sk: { sessions: skSessions, clients: skClients, components: skComponents, docbuilder: skDocbuilder },
  tr: { sessions: trSessions, clients: trClients, components: trComponents, docbuilder: trDocbuilder },
  'zh-CN': { sessions: zhCnSessions, clients: zhCnClients, components: zhCnComponents, docbuilder: zhCnDocbuilder },
  'zh-HK': { sessions: zhHkSessions, clients: zhHkClients, components: zhHkComponents, docbuilder: zhHkDocbuilder },
};
